import React from 'react'
import Chart from 'react-apexcharts'
import ChartCard from './ChartCard'
import { formatCurrency } from '../mockData'

export default function TopClientsChart({ data }) {
    const options = {
        chart: {
            type: 'bar',
            toolbar: { show: false },
            animations: { enabled: true, easing: 'easeinout', speed: 800 },
        },
        plotOptions: {
            bar: {
                horizontal: true,
                borderRadius: 6,
                barHeight: '60%',
                distributed: true,
            },
        },
        xaxis: {
            categories: data.map((c) => c.name),
            labels: {
                style: { colors: '#64748B', fontSize: '12px' },
                formatter: (val) => `R$ ${(val / 1000).toFixed(0)}k`,
            },
        },
        yaxis: {
            labels: {
                style: { colors: '#64748B', fontSize: '11px' },
                maxWidth: 180,
            },
        },
        colors: [
            '#3B82F6', '#60A5FA', '#93C5FD', '#3B82F6', '#60A5FA',
            '#93C5FD', '#3B82F6', '#60A5FA', '#93C5FD', '#BFDBFE',
        ],
        legend: { show: false },
        tooltip: {
            theme: 'light',
            y: { formatter: (val) => formatCurrency(val) },
        },
        grid: {
            borderColor: '#E2E8F0',
            strokeDashArray: 4,
        },
        dataLabels: {
            enabled: true,
            formatter: (val) => formatCurrency(val),
            style: { fontSize: '11px', fontWeight: 600, colors: ['#fff'] },
        },
    }

    const series = [{
        name: 'Receita',
        data: data.map((c) => c.value),
    }]

    return (
        <ChartCard title="Top 10 Clientes por Receita" subtitle="Receita acumulada no período">
            <Chart options={options} series={series} type="bar" height={380} />
        </ChartCard>
    )
}
